import OwaOtherMailboxConfiguration from 'owa-service/lib/contract/OwaOtherMailboxConfiguration';
import getOtherMailboxConfigurationOperation from 'owa-service/lib/operation/getOtherMailboxConfigurationOperation';

export default function getOtherMailboxConfiguration(): Promise<OwaOtherMailboxConfiguration> {
    return getOtherMailboxConfigurationOperation({});
}
